import React, { useState, useEffect } from 'react'
import SideBar from '../sidebar/sidebar'
import Table from "../table/table"
import api from "../api/api.list"
import TopBar from '../topbar/topbar'
import userapi from "../api/api.userlist"
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import baseUrl from '../config.json'
import socketIOClient from "socket.io-client";
const ENDPOINT = baseUrl.apiEndPoint;

function Search() {

  const [mrnumber, setMrNumber] = useState('')
  const [name, setName] = useState('')
  const [insurance, setInsurance] = useState('')
  const [drname, setDrName] = useState('')
  const [startDate, setStartDate] = useState('')
  const [endDate, setEndDate] = useState('')
  const [requestdatefrom, setRequestDateFrom] = useState('')
  const [requestdateto, setRequestDateTo] = useState('')
  const [requestenteredfrom, setRequestEnteredFrom] = useState('')
  const [requestenteredto, setRequestEnteredTo] = useState('')
  const [createdby, setCreatedBy] = useState('')
  const [status, setStatus] = useState('')
  const [list, setList] = useState([])
  const [userlist, setUser] = useState([])
  useEffect(() => {
    const socket = socketIOClient(ENDPOINT);
    socket.on("FromAPI", data => {
      //getSearchData()
    });
    getuser()
  }, [])
  const getuser = () => {
    userapi.getuser().then(res => {
      console.log(res.data)
      setUser(res.data)
    })
  }
  const getCount = () => {

  }
  const getSearchData = () => {

    // api.searchlist(data).then(res => {
    //   setList(res.data)
    // }
    // )
    let data = {
      "startDate": startDate,
      "endDate": endDate,
      "requestdatefrom": requestdatefrom,
      "requestdateto": requestdateto,
      "requestenteredfrom": requestenteredfrom,
      "requestenteredto": requestenteredto,
      "mrnumber": mrnumber,
      "name": name,
      "insurance": insurance,
      "drname": drname,
      "createdby": createdby,
      "status": status
    }
    api.searchdate(data).then(res => {
      setList(res.data)
    }
    )
  }
  return (<div class="wrapper">

    <SideBar />

    <div class="main-panel">
      <TopBar />
      <div class="content" >
        <div class="container-fluid">
          <div class="row" >
            <div class="col-lg-12 col-md-12">
              <div class="card">
                <div class="header">
                  <h5 class="title">Search</h5>
                </div>
                <div class="content" style={{ 'padding': '15px' }}>
                  <form>

                    <div class="row">
                      <div class="col-md-3">
                        <div class="form-group">
                          <label>Mr Number</label>
                          <input type="text" autoComplete="off"  class="form-control border-input" disabled="" placeholder="Mr Number" value={mrnumber} onChange={(e) => {
                            setMrNumber(e.target.value)
                          }}></input>
                        </div>
                      </div>
                      <div class="col-md-3">
                        <div class="form-group">
                          <label>Name</label>
                          <input type="text" class="form-control border-input" autoComplete="off"  disabled="" placeholder="Name" value={name} onChange={(e) => {
                            setName(e.target.value)
                          }}></input>
                        </div>
                      </div>
                      <div class="col-md-3">
                        <div class="form-group">
                          <label>Insurance</label>
                          <input type="text" class="form-control border-input" autoComplete="off"  placeholder="Insurance" value={insurance} onChange={(e) => {
                            setInsurance(e.target.value)
                          }}></input>
                        </div>
                      </div>

                      <div class="col-md-3">
                        <div class="form-group">
                          <label>Dr Name</label>
                          <input type="text" class="form-control border-input" autoComplete="off"  placeholder="Dr Name" value={drname} onChange={(e) => {
                            setDrName(e.target.value)
                          }}></input>
                        </div>
                      </div>
                    </div>

                    <div class="row">
                      <div class="col-md-3">
                        <div class="form-group">
                          <label for="exampleInputEmail1">Visit Date From</label>
                          <div class="form-control border-input" >
                          <DatePicker selected={startDate} style="border:none" autoComplete="off" name="startDate" isClearable value={startDate} onChange={e => {
                            setStartDate(e) 
                            //alert(date)
                          }}
                           /></div>
                          {/* <input DatePicker selected={startDate}  class="form-control border-input" placeholder="Visit Date From" value={startDate} onChange={(e) => {
                            setStartDate(e.target.value)
                          }}></input> */}
                        </div>
                      </div>

                      <div class="col-md-3">
                        <div class="form-group">
                          <label for="exampleInputEmail1">Visit Date To</label>
                          <div class="form-control border-input" >
                          <DatePicker selected={endDate} name="endDate" autoComplete="off" isClearable value={endDate} onChange={(e) => {
                            setEndDate(e)
                          }}
                            class="form-control border-input" /></div>
                          {/* <input type="Date" class="form-control border-input" placeholder="Visit Date To" value={endDate} onChange={(e) => {
                            setEndDate(e.target.value)
                          }}></input> */}
                        </div>
                      </div>

                      <div class="col-md-3">
                        <div class="form-group">
                          <label>Request Received From</label>
                          <div class="form-control border-input" >
                         <DatePicker selected={requestdatefrom} name="requestdatefrom" autoComplete="off" isClearable value={requestdatefrom} onChange={(e) => {
                            setRequestDateFrom(e)
                          }}
                            class="form-control border-input" /> </div>


                          {/* <input type="Date" class="form-control border-input" placeholder="Request Received Date From" value={requestdatefrom} onChange={(e) => {
                            setRequestDateFrom(e.target.value)
                          }}></input> */}
                        </div>
                      </div>


                      <div class="col-md-3">
                        <div class="form-group">
                          <label>Request Received To</label>
                          <div class="form-control border-input" >
                          <DatePicker selected={requestdateto} name="requestdateto" autoComplete="off" isClearable value={requestdateto} onChange={(e) => {
                            setRequestDateTo(e)
                          }}
                            class="form-control border-input" /></div>

                          {/* <input type="Date" class="form-control border-input" placeholder="Request Received Date To" value={requestdateto} onChange={(e) => {
                            setRequestDateTo(e.target.value)
                          }}></input> */}
                        </div>
                      </div>

                    </div>

                    <div class="row">
                      {localStorage.role != 'ROLE_USER' &&
                        <div class="col-md-3">
                          <div class="form-group">
                            <label>Request Entered From</label>
                            <div class="form-control border-input" >
                            <DatePicker selected={requestenteredfrom} name="requestenteredfrom" autoComplete="off" isClearable value={requestenteredfrom} onChange={(e) => {
                              setRequestEnteredFrom(e)
                            }}
                              class="form-control border-input" /></div>
                            {/* <input type="Date" class="form-control border-input" placeholder="Request Entered Date From" value={requestenteredfrom} onChange={(e) => {
                              setRequestEnteredFrom(e.target.value)
                            }}></input> */}
                          </div>
                        </div>}



                      {localStorage.role != 'ROLE_USER' &&
                        <div class="col-md-3">
                          <div class="form-group">
                            <label>Request Entered To</label>
                            <div class="form-control border-input" >
                            <DatePicker selected={requestenteredto} name="requestenteredto" autoComplete="off" isClearable value={requestenteredto} onChange={(e) => {
                              setRequestEnteredTo(e)
                            }}
                              class="form-control border-input" /></div>

                          </div>
                        </div>}


                      {localStorage.role != 'ROLE_USER' &&
                        <div class="col-md-3">
                          <div class="form-group">

                            <label>Approval Status</label>


                            <select name="approvalstatus" class="form-control border-input" value={status} onChange={(e) => {
                              setStatus(e.target.value)
                            }}>
                              <option value="">All</option>
                              <option value="5">Cancelled</option>
                              <option value="4">Partially Approved</option>
                              <option value="3">Query</option>
                              <option value="2">Approved</option>
                              <option value="1">Denied</option>
                              <option value="0">Pending</option></select>

                          </div>
                        </div>}

                      {localStorage.role != 'ROLE_USER' &&
                        <div class="col-md-3">
                          <div class="form-group">
                            <label>Submitted By</label>
                            {/* <input type="text" class="form-control border-input" placeholder="Submitted By" value={createdby} onChange={(e) => {
                              alert(e.target.value)
                              setCreatedBy(e.target.value)
                            }}></input> */}
                            <select class="form-control border-input" onChange={(e) => { setCreatedBy(e.target.value) }} >
                              (<option key="-1" value="" >All</option>{

                                userlist.map((user) => {
                                  return (
                                    user.roles[0].name == 'admin' &&
                                    <option key={user._id} value={user._id} >{user.username}</option>
                                  )
                                }
                                )
                              })
                            </select>
                          </div>
                        </div>
                      }

                      <div class="col-md-3">
                        <div class="form-group">
                          <div style={{ 'margin': '0px 10px' }}>
                            <button type="submit" class="btn btn-info btn-fill btn-wd" onClick={(e) => {
                              //alert(createdby)
                              e.preventDefault()
                              getSearchData()
                            }}>Search</button>
                          </div>
                        </div>
                      </div>

                    </div>



                    <div class="clearfix"></div>
                  </form>
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            {list!=null&&list.length>0&&
              <Table list={list} getlist={getSearchData} getCount={getCount} />
            }
          </div>
        </div>

      </div>
    </div>
  </div>

  )
}
export default Search